import CostOfStatusQuoChart from "./CostOfStatusQuoChart";

export default CostOfStatusQuoChart;
